import { globalGetService } from '@/utils/globalApiServices';
import {
  BrandSuggestionParams,
  BrandSuggestion,
  BrandAsset,
  MnoSuspensionStatus,
} from './types';

export const getBrandSuggestions = async (
  queries: BrandSuggestionParams = {}
): Promise<BrandSuggestion[]> => {
  const response = await globalGetService('dca/brands/suggestions', queries);
  return response?.ok ? response.data : [];
};

export const getBrandAssets = async (
  brandUid: string,
  params?: { verificationStatus?: string }
): Promise<BrandAsset[]> => {
  const response = await globalGetService(
    `dca/brands/${brandUid}/assets`,
    params
  );
  return response?.ok ? response.data : [];
};

export const getMnoSuspensionStatus = async (brandId: string) => {
  const response = await globalGetService(
    `dca/brands/${brandId}/mnoSuspensionStatus`
  );
  return response?.ok ? (response.data as MnoSuspensionStatus[]) : [];
};
